import React from 'react';
import { careersTab } from '../../copy/advisor-dashboard/careers-degrees-tab.json';

const CareerDetails = ({ details }) => {
  const displayKeyValuePairs = (key, value) => {
    return (
      <div className="details-dropdown__row">
        <p className="details-dropdown__details-label">{key}</p>
        <p className="details-dropdown__details-value">{value}</p>
      </div>
    );
  };

  return (
    <>
      <div className="details-dropdown__details details-dropdown__onet-code">
        <p className="details-dropdown__details-label">{careersTab.onetCode}</p>
        <p className="details-dropdown__details-value">{details.onetCode}</p>
      </div>
      <div className="details-dropdown__details details-dropdown__description">
        <p className="details-dropdown__details-label">
          {careersTab.descriptionEn}
        </p>
        <p className="details-dropdown__details-value">
          {details.descriptionEn}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__career-category">
        <p className="details-dropdown__details-label">
          {careersTab.careerCategory}
        </p>
        <p className="details-dropdown__details-value">
          {details.careerCategory}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__bright-outlook">
        <p className="details-dropdown__details-label">
          {careersTab.brightOutlook}
        </p>
        <p className="details-dropdown__details-value">
          {details.brightOutlook}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__career-tasks">
        <p className="details-dropdown__details-label">{careersTab.tasks}</p>
        <div className="details-dropdown__tasks-container">
          {Object.values(details.tasksEn).map((task) => (
            <p
              className="details-dropdown__details-value details-dropdown__task"
              key={task}
            >
              {task}
            </p>
          ))}
        </div>
      </div>
      <div className="details-dropdown__riasec-and-skills">
        <div className="details-dropdown__details details-dropdown__riasec-container">
          <p className="details-dropdown__details-header details-dropdown__riasec-skills-header">
            {careersTab.riasecHeader}
          </p>
          {displayKeyValuePairs(careersTab.rVal, details.rVal)}
          {displayKeyValuePairs(careersTab.iVal, details.iVal)}
          {displayKeyValuePairs(careersTab.aVal, details.aVal)}
          {displayKeyValuePairs(careersTab.sVal, details.sVal)}
          {displayKeyValuePairs(careersTab.eVal, details.eVal)}
          {displayKeyValuePairs(careersTab.cVal, details.cVal)}
        </div>
        <div className="details-dropdown__details details-dropdown__skills-container">
          <p className="details-dropdown__details-header details-dropdown__riasec-skills-header">
            {careersTab.skillsHeader}
          </p>
          {displayKeyValuePairs(
            careersTab.communication,
            details.communication
          )}
          {displayKeyValuePairs(
            careersTab.computerTechnical,
            details.computerTechnical
          )}
          {displayKeyValuePairs(
            careersTab.criticalThinking,
            details.criticalThinking
          )}
          {displayKeyValuePairs(
            careersTab.interpersonal,
            details.interpersonal
          )}
          {displayKeyValuePairs(
            careersTab.problemSolving,
            details.problemSolving
          )}
          {displayKeyValuePairs(careersTab.mathematics, details.mathematics)}
          {displayKeyValuePairs(careersTab.creativity, details.creativity)}
        </div>
      </div>
    </>
  );
};

export default CareerDetails;
